
import React, { useState } from 'react';
import { 
  Collapsible, 
  CollapsibleContent, 
  CollapsibleTrigger 
} from '@/components/ui/collapsible';
import { Button } from '@/components/ui/button';
import TranslatedText from '@/TranslatedText';

interface FAQItemProps {
  question: React.ReactNode;
  answer: React.ReactNode;
}

const FAQItem = ({ question, answer }: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen} className="border rounded-lg overflow-hidden mb-3">
      <CollapsibleTrigger className="flex justify-between items-center w-full p-4 text-left bg-gray-50 hover:bg-gray-100">
        <h3 className="text-lg font-medium">{question}</h3>
        <Button variant="ghost" size="sm">
          {isOpen ? <TranslatedText text="Hide" /> : <TranslatedText text="Show" />}
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent className="p-4 bg-white">
        <p className="text-gray-700">{answer}</p>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default FAQItem;
